const indices = [
  { icon: 'ri-fire-line', title: '本周热门', desc: '人气飙升最快的下拉式漫画作品合集', count: 128, color: 'text-primary-500' },
  { icon: 'ri-star-line', title: '高分神作', desc: '评分9.0以上的口碑下拉式漫画', count: 356, color: 'text-secondary-500' },
  { icon: 'ri-rocket-line', title: '最新上架', desc: '最近一周新增的下拉式漫画资源', count: 89, color: 'text-accent-500' },
  { icon: 'ri-heart-line', title: '恋爱专区', desc: '甜到心底的恋爱下拉式漫画合集', count: 412, color: 'text-primary-500' },
  { icon: 'ri-sword-line', title: '热血战斗', desc: '燃爆肾上腺素的战斗下拉式漫画', count: 287, color: 'text-secondary-500' },
  { icon: 'ri-magic-line', title: '奇幻冒险', desc: '异世界与魔法下拉式漫画大全', count: 345, color: 'text-accent-500' },
  { icon: 'ri-emotion-laugh-line', title: '搞笑日常', desc: '轻松解压的搞笑下拉式漫画合集', count: 198, color: 'text-primary-500' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">分类索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            按主题快速浏览，精准找到你想看的下拉式漫画类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indices.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-start gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ${idx % 3 === 0 ? 'bg-primary-50' : idx % 3 === 1 ? 'bg-accent-50' : 'bg-secondary-50'}`}>
                <i className={`${item.icon} text-lg ${item.color}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}部</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-4 flex justify-center pt-2">
            <a
              href="#topics"
              onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-primary-500 hover:text-primary-600 bg-primary-50 hover:bg-primary-100 rounded-full transition-colors duration-200 no-underline cursor-pointer"
            >
              查看全部分类
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}